'use client';

import { useTheme } from '@/contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ThemeToggle({ className }: { className?: string }) {
  const { themeMode, setThemeMode } = useTheme();
  const isDark = themeMode === 'dark';

  return (
    <button
      type="button"
      aria-label="Alternar tema"
      className={cn(
        'relative flex items-center w-16 h-8 rounded-full transition-colors duration-300 focus:outline-none',
        isDark ? 'bg-zinc-900' : 'bg-zinc-100',
        className
      )}
      onClick={() => setThemeMode(isDark ? 'light' : 'dark')}
    >
      {/* Lua */}
      <span className="flex items-center justify-center w-8 h-8">
        <Moon className={cn('w-5 h-5', isDark ? 'text-white' : 'text-zinc-400')} />
      </span>
      {/* Sol */}
      <span className="flex items-center justify-center w-8 h-8">
        <Sun className={cn('w-5 h-5', isDark ? 'text-zinc-400' : 'text-yellow-500')} />
      </span>
      {/* Círculo deslizante */}
      <span
        className={cn(
          'absolute top-1 left-1 w-6 h-6 rounded-full bg-white shadow-md transition-transform duration-300',
          isDark ? 'translate-x-8 bg-zinc-800' : 'translate-x-0'
        )}
      />
    </button>
  );
}
